import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { 
  trackPageView, 
  setAnalyticsUserId, 
  setAnalyticsUserProperties,
  isAnalyticsInitialized 
} from '../services/analyticsService';

/**
 * Hook to automatically track page views on route changes
 */
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (isAnalyticsInitialized()) {
      // Small delay to ensure page title is updated
      setTimeout(() => {
        trackPageView(location.pathname, document.title);
      }, 100);
    }
  }, [location]);
};

/**
 * Hook to set user analytics properties when user logs in
 * @param {Object} user - User object with id, email, role, etc.
 */
export const useUserAnalytics = (user) => {
  useEffect(() => {
    if (!user || !isAnalyticsInitialized()) {
      return;
    }

    // Set user ID
    if (user.uid) {
      setAnalyticsUserId(user.uid);
    }

    // Set user properties
    const userProperties = {
      user_id: user.uid,
      user_email: user.email || '',
    };

    if (user.role) {
      userProperties.user_role = user.role;
    }

    if (user.displayName) {
      userProperties.user_name = user.displayName;
    }

    setAnalyticsUserProperties(userProperties);
  }, [user]);
};

